export default __webpack_public_path__ + "static/media/mobile_app_icon.aa2bb06f.svg";